import { render, staticRenderFns } from "./Welcoming.vue?vue&type=template&id=7d5a39cd&scoped=true&"
import script from "./Welcoming.vue?vue&type=script&lang=ts&"
export * from "./Welcoming.vue?vue&type=script&lang=ts&"
import style0 from "./Welcoming.vue?vue&type=style&index=0&id=7d5a39cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a39cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
